module.exports = __webpack_public_path__ + "static/media/image12.772f3f5d.png";